<div
  class="w-100 h-100 d-flex flex-column py-2 px-2"
>
  <div
    class="d-flex align-items-center justify-content-between mb-2 w-100"
  >
    <div class="d-flex align-items-center gap-2">
      <div class="fw-bold text-truncate">
        {{ title }}
      </div>
      <!-- Filtre Catégorie à côté du titre -->
      @if (activateCategory && availableCategories.length) {
      <div ngbDropdown container="body">
        <button
          ngbDropdownToggle
          class="badge rounded-pill bg-primary d-flex align-items-center"
        >
          Catégories
        </button>
        <div ngbDropdownMenu>
          @for (cat of availableCategories; track cat) {
          <button
            class="dropdown-item d-flex align-items-center"
            type="button"
            (click)="onCategoryToggle(cat)"
          >
            <input
              type="checkbox"
              class="form-check-input me-2"
              [checked]="selectedCategoryCodes.includes(cat.code)"
              tabindex="-1"
              readonly
            />
            <i
              *ngIf="cat.icon"
              class="me-2"
              [class]="cat.icon"
              [style.color]="cat.color || null"
              aria-hidden="true"
            ></i>
            {{ cat.name }}
          </button>
          }
        </div>
      </div>
      }
      <!-- Filtre Mois à côté du titre -->
      @if (availableMonths.length) {
      <div ngbDropdown container="body" [autoClose]="'outside'">
        <button ngbDropdownToggle class="badge rounded-pill bg-primary">
          Mensuel
        </button>
        <div ngbDropdownMenu>
          <!-- Bouton "Tout" -->
          <button
            class="dropdown-item d-flex align-items-center fw-bold"
            type="button"
            (click)="toggleAllMonths($event)"
          >
            <input
              type="checkbox"
              class="form-check-input me-2"
              [checked]="areAllMonthsSelected()"
              tabindex="-1"
              readonly
            />
            {{ "dashboard.all" | translate }}
          </button>
          <div class="dropdown-divider"></div>
          @for (month of availableMonths; track month) {
          <button
            class="dropdown-item d-flex align-items-center"
            type="button"
            (click)="toggleMonth(month, $event)"
          >
            <input
              type="checkbox"
              class="form-check-input me-2"
              [checked]="selectedMonths?.includes(month)"
              tabindex="-1"
              readonly
            />
            {{ "MONTHS." + month | translate }}
          </button>
          }
        </div>
      </div>
      }
    </div>
    <!-- Bouton déplacer à droite -->
    <i class="bi bi-arrows-fullscreen text-primary" style="cursor: move;"></i>
  </div>
  
  <!-- Contenu du graphique centré dans l'espace restant -->
  <div class="flex-grow-1 d-flex align-items-center justify-content-center">
    @if (barChartData.labels?.length && barChartData.datasets) {
    <canvas
      baseChart
      [data]="barChartData"
      [type]="barChartType"
      [options]="barChartOptions"
      (chartClick)="onBarClick($event)"
    ></canvas>
    } @else {
    <div class="text-muted text-center w-100">
      <i class="fas fa-chart-bar fa-2x mb-2"></i>
      <div>Aucune donnée à afficher</div>
    </div>
    }
  </div>
</div>
